import React from 'react';
import Header from '../homepage/components/Header';
import Footer from '../homepage/components/Footer';
import Seo from '../../components/Seo';
import { FAQ_CLUSTERS, getFaqPageSchema } from '../../content/faqs';

export default function FaqPage() {
  return (
    <>
      <Seo
        title="FAQ - Skyline VFX"
        description="Frequently asked questions about Skyline VFX (digital matte painting and concept art)."
        schema={getFaqPageSchema()}
      />
      <div className="min-h-screen text-white">
        <Header />
        <main className="pt-32 pb-20 px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl lg:text-5xl font-bold mb-6">Frequently Asked Questions</h1>
            <p className="text-gray-300 mb-12">
              Clear, factual answers designed to be easy for both people and machines to understand.
            </p>

            <div className="space-y-14">
              {FAQ_CLUSTERS.map((cluster) => (
                <section key={cluster.id} className="space-y-6">
                  <h2 className="text-2xl font-semibold text-white">{cluster.title}</h2>
                  <div className="space-y-6">
                    {cluster.items.map((f) => (
                      <section key={`${cluster.id}:${f.question}`} className="border border-white/10 bg-white/5 p-6">
                        <h3 className="text-xl font-semibold text-white">{f.question}</h3>
                        <p className="text-gray-300 mt-2">{f.answer}</p>
                      </section>
                    ))}
                  </div>
                </section>
              ))}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}

